import {createContext, useContext, ReactNode} from 'react';

export interface FeatureFlags {
  newUniversalHelpDesign: boolean;
  universalHelpDotComDesign: boolean;
  dotComFeedbackButtons: boolean;
  dotComNoLlm: boolean;
  dotComCsf: boolean;
  messagesTopAnchored: boolean;
  inlineRacEmailForm: boolean;
  universalHelpDrawerEnabled: boolean;
  conversationsLiveAnswersRow: boolean;
  universalHelpEncourageMoreDetailFromUserMse5042: boolean;
  enableScreenshareUi: boolean;
}

export const defaultFlags: FeatureFlags = {
  newUniversalHelpDesign: false,
  universalHelpDotComDesign: false,
  dotComFeedbackButtons: false,
  dotComNoLlm: false,
  dotComCsf: false,
  messagesTopAnchored: false,
  inlineRacEmailForm: false,
  universalHelpDrawerEnabled: false,
  conversationsLiveAnswersRow: false,
  universalHelpEncourageMoreDetailFromUserMse5042: false,
  enableScreenshareUi: false,
};

type Props = {
  value: Partial<FeatureFlags>;
  children: ReactNode;
};

const FeatureFlagsProviderContext = createContext<FeatureFlags>(defaultFlags);

export function FeatureFlagsProvider({value = {}, children}: Props) {
  return (
    <FeatureFlagsProviderContext.Provider value={{...defaultFlags, ...value}}>
      {children}
    </FeatureFlagsProviderContext.Provider>
  );
}

export function useConversationUIFeatureFlags() {
  return useContext(FeatureFlagsProviderContext);
}

export function useNewUniversalHelpDesign() {
  const {newUniversalHelpDesign} = useConversationUIFeatureFlags();
  return newUniversalHelpDesign;
}

export function useDotComFeedbackButtons() {
  const {dotComFeedbackButtons} = useConversationUIFeatureFlags();
  return dotComFeedbackButtons;
}

export function useDotComNoLlm() {
  const {dotComNoLlm} = useConversationUIFeatureFlags();
  return dotComNoLlm;
}

export function useDotComCsf() {
  const {dotComCsf} = useConversationUIFeatureFlags();
  return dotComCsf;
}

export function useUniversalHelpDotComDesign() {
  const {universalHelpDotComDesign} = useConversationUIFeatureFlags();
  return universalHelpDotComDesign;
}

export function useMessagesTopAnchored() {
  const {messagesTopAnchored} = useConversationUIFeatureFlags();
  return messagesTopAnchored;
}

export function useInlineRacEmailForm() {
  const {inlineRacEmailForm} = useConversationUIFeatureFlags();
  return inlineRacEmailForm;
}

export function useUniversalHelpDrawerEnabled() {
  const {universalHelpDrawerEnabled} = useConversationUIFeatureFlags();
  return universalHelpDrawerEnabled;
}

export function useConversationsLiveAnswersRow() {
  const {conversationsLiveAnswersRow} = useConversationUIFeatureFlags();
  return conversationsLiveAnswersRow;
}

export function useUniversalHelpEncourageMoreDetailFromUserMse5042Enabled() {
  const {universalHelpEncourageMoreDetailFromUserMse5042} =
    useConversationUIFeatureFlags();
  return universalHelpEncourageMoreDetailFromUserMse5042;
}

export function useEnabledScreenshareUi() {
  const {enableScreenshareUi} = useConversationUIFeatureFlags();
  return enableScreenshareUi;
}
